// Services shown on the site. `duration` is displayed on each service card and
// in the booking panel ("2h" shows as "2 hr").

export const services = [
  {
    id: 1,
    name: "Small Knotless Braids",
    duration: "8h",
    price: 200,
    category: "Knotless Braids",
    description: "Knotless braids — small section size.",
  },
  {
    id: 2,
    name: "Medium Knotless Braids",
    duration: "6h",
    price: 150,
    category: "Knotless Braids",
    description: "Knotless braids — medium section size.",
  },
  {
    id: 3,
    name: "Large Knotless Braids",
    duration: "4h",
    price: 95,
    category: "Knotless Braids",
    description: "Knotless braids — large section size.",
  },
  {
    id: 4,
    name: "Small Boho Braids",
    duration: "8h",
    price: 230,
    category: "Boho Braids",
    description: "Boho braids with curly ends — small size.",
  },
  {
    id: 5,
    name: "Medium Boho Braids",
    duration: "6h",
    price: 180,
    category: "Boho Braids",
    description: "Boho braids with curly ends — medium size.",
  },
  {
    id: 6,
    name: "Large Boho Braids",
    duration: "4h",
    price: 125,
    category: "Boho Braids",
    description: "Boho braids with curly ends — large size.",
  },
  {
    id: 7,
    name: "Island Twist",
    duration: "4h",
    price: 150,
    category: "Twists",
    description: "Island twist install.",
  },
  {
    id: 8,
    name: "Wig Install",
    duration: "2h",
    price: 75,
    category: "Wigs",
    description: "Wig install service.",
  },
  {
    id: 9,
    name: "Dread Retwist",
    duration: "2h",
    price: 65,
    category: "Locs",
    description: "Loc maintenance — root retwist.",
  },
  {
    id: 10,
    name: "Kids' Hair Styles",
    duration: "2h",
    price: 65,
    category: "Kids",
    description: "Hair styles for kids ages 2–12.",
  },
];

export const stylists = [
  {
    id: 1,
    name: "Trinya Marieee",
    title: "Founder & Master Stylist",
    specialty: "Braids, Wigs & Locs",
    rating: 5.0,
    reviews: 0,
    img: "/images/stylist-trinya.jpg",
  },
];

export const reviews = [
  {
    name: "Client",
    text: "She absolutely nailed it — I can't stop obsessing over my hair.",
    rating: 5,
    service: "Styling",
  },
  {
    name: "Client",
    text: "The best stylist ever — my hair turned out flawless!",
    rating: 5,
    service: "Styling",
  },
];

export const galleryImages = [
  "/images/gallery-cornrows.jpg",
  "/images/gallery-boho.jpg",
  "/images/gallery-burgundy.jpg",
  "/images/gallery-sleek.jpg",
  "/images/gallery-knotless.jpg",
  "/images/gallery-red-install.jpg",
  "/images/gallery-locs.jpg",
  "/images/gallery-braids.jpg",
];
